// import React, { useState, useEffect } from 'react';
// import { getServices, createService, updateService, deleteService } from '../utils/api';
// import toast from 'react-hot-toast';

// const ICONS = ['Home', 'Building', 'Key', 'Layers', 'ChefHat', 'Hammer', 'Star', 'Shield', 'Award', 'Brush'];
// const initForm = { title: '', description: '', icon: 'Home', features: '', isPublished: true, order: 0 };

// export default function ServicesPage() {
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [modal, setModal] = useState(null);
//   const [form, setForm] = useState(initForm);
//   const [saving, setSaving] = useState(false);

//   const fetch = () => {
//     setLoading(true);
//     getServices().then(r => setServices(r.data.data)).catch(() => {}).finally(() => setLoading(false));
//   };
//   useEffect(() => { fetch(); }, []);

//   const openEdit = (s) => {
//     setForm({ title: s.title, description: s.description, icon: s.icon || 'Home', features: (s.features || []).join('\n'), isPublished: s.isPublished, order: s.order || 0 });
//     setModal(s._id);
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();
//     if (!form.title || !form.description) { toast.error('Title and description required'); return; }
//     setSaving(true);
//     try {
//       const payload = { ...form, features: form.features ? form.features.split('\n').map(s => s.trim()).filter(Boolean) : [] };
//       if (modal === 'new') await createService(payload);
//       else await updateService(modal, payload);
//       toast.success('Saved');
//       setModal(null);
//       fetch();
//     } catch { toast.error('Save failed'); }
//     finally { setSaving(false); }
//   };

//   const handleDelete = async (id, title) => {
//     if (!window.confirm(`Delete service "${title}"?`)) return;
//     try { await deleteService(id); toast.success('Deleted'); fetch(); }
//     catch { toast.error('Failed'); }
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
//   };

//   return (
//     <div className="space-y-5">
//       <div className="flex items-center justify-between">
//         <div>
//           <h1 className="font-display text-xl font-semibold text-surface-100">Services</h1>
//           <p className="text-surface-500 text-sm mt-0.5">{services.length} services</p>
//         </div>
//         <button onClick={() => { setForm(initForm); setModal('new'); }} className="btn-primary">+ Add Service</button>
//       </div>

//       {loading ? (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//           {[...Array(6)].map((_, i) => <div key={i} className="card h-36 animate-pulse" />)}
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//           {services.map(s => (
//             <div key={s._id} className="card p-5 space-y-3">
//               <div className="flex items-start justify-between gap-2">
//                 <div className="w-10 h-10 bg-brand-400/15 rounded-lg flex items-center justify-center text-brand-400 text-lg">{s.icon?.[0] || '◆'}</div>
//                 <span className={`text-xs px-2 py-0.5 rounded-full ${s.isPublished ? 'bg-green-500/15 text-green-400' : 'bg-surface-700 text-surface-500'}`}>
//                   {s.isPublished ? 'Live' : 'Hidden'}
//                 </span>
//               </div>
//               <div>
//                 <h3 className="text-surface-200 font-medium text-sm">{s.title}</h3>
//                 <p className="text-surface-500 text-xs mt-1 line-clamp-2">{s.description}</p>
//               </div>
//               {s.features?.length > 0 && (
//                 <div className="flex flex-wrap gap-1">
//                   {s.features.slice(0, 2).map((f, i) => <span key={i} className="bg-surface-700 text-surface-400 text-xs px-2 py-0.5 rounded">{f}</span>)}
//                   {s.features.length > 2 && <span className="text-surface-600 text-xs px-1">+{s.features.length - 2}</span>}
//                 </div>
//               )}
//               <div className="flex gap-2 pt-1">
//                 <button onClick={() => openEdit(s)} className="btn-secondary py-1 px-3 text-xs">Edit</button>
//                 <button onClick={() => handleDelete(s._id, s.title)} className="text-red-500 hover:text-red-400 text-xs transition-colors px-2">Delete</button>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {modal !== null && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-surface-900/80 backdrop-blur-sm">
//           <div className="bg-surface-800 border border-surface-700 rounded-lg w-full max-w-lg p-6 max-h-[90vh] overflow-y-auto">
//             <div className="flex items-center justify-between mb-5">
//               <h2 className="font-display font-semibold text-surface-100">{modal === 'new' ? 'Add Service' : 'Edit Service'}</h2>
//               <button onClick={() => setModal(null)} className="text-surface-500 hover:text-surface-300">✕</button>
//             </div>
//             <form onSubmit={handleSave} className="space-y-4">
//               <div>
//                 <label className="label">Service Title *</label>
//                 <input name="title" value={form.title} onChange={handleChange} className="input" placeholder="e.g. Residential Design" required />
//               </div>
//               <div>
//                 <label className="label">Icon</label>
//                 <select name="icon" value={form.icon} onChange={handleChange} className="input">
//                   {ICONS.map(i => <option key={i} value={i}>{i}</option>)}
//                 </select>
//               </div>
//               <div>
//                 <label className="label">Description *</label>
//                 <textarea name="description" value={form.description} onChange={handleChange} className="input resize-none" rows={3} required />
//               </div>
//               <div>
//                 <label className="label">Features (one per line)</label>
//                 <textarea name="features" value={form.features} onChange={handleChange} className="input resize-none" rows={4} placeholder={"Feature 1\nFeature 2"} />
//               </div>
//               <div className="flex items-center gap-4">
//                 <label className="flex items-center gap-2 cursor-pointer">
//                   <input type="checkbox" name="isPublished" checked={form.isPublished} onChange={handleChange} className="accent-brand-400" />
//                   <span className="text-surface-300 text-sm">Published</span>
//                 </label>
//                 <div className="flex items-center gap-2">
//                   <label className="label mb-0">Order</label>
//                   <input type="number" name="order" value={form.order} onChange={handleChange} className="input w-20 py-1" min={0} />
//                 </div>
//               </div>
//               <div className="flex gap-3">
//                 <button type="submit" disabled={saving} className="btn-primary flex-1">{saving ? 'Saving…' : 'Save'}</button>
//                 <button type="button" onClick={() => setModal(null)} className="btn-secondary flex-1">Cancel</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Plus, Edit, Trash2, Wrench } from 'lucide-react';
import { getAdminServices, createService, updateService, deleteService } from '../utils/api';
import toast from 'react-hot-toast';
import ConfirmModal from '../components/ConfirmModal';

const emptyForm = { title: '', icon: '', short_description: '', description: '', is_active: true, sort_order: 0 };

function ServiceModal({ service, onSave, onClose }) {
  const [form, setForm] = useState(service ? { ...service } : emptyForm);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.short_description.trim()) { toast.error('Title and description required'); return; }
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => {
        if (v !== null && v !== undefined) fd.append(k, v === true ? '1' : v === false ? '0' : v);
      });
      if (service?.id) fd.append('_method', 'PUT');
      await onSave(form, service?.id);
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="w-full max-w-lg bg-surface-800 border border-white/10 rounded-xl overflow-hidden">
        <div className="flex items-center justify-between p-5 border-b border-white/8">
          <h3 className="font-semibold text-white">{service ? 'Edit Service' : 'Add Service'}</h3>
          <button onClick={onClose} className="btn-ghost p-1.5"><span className="text-lg">×</span></button>
        </div>
        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label">Title *</label>
              <input name="title" value={form.title} onChange={handleChange} placeholder="Service title" className="input" />
            </div>
            <div>
              <label className="label">Icon</label>
              <input name="icon" value={form.icon} onChange={handleChange} placeholder="e.g. Palette" className="input" />
            </div>
          </div>
          <div>
            <label className="label">Short Description *</label>
            <textarea name="short_description" value={form.short_description} onChange={handleChange} rows={2} className="input resize-none" />
          </div>
          <div>
            <label className="label">Full Description</label>
            <textarea name="description" value={form.description || ''} onChange={handleChange} rows={3} className="input resize-none" />
          </div>
          <div className="flex items-center gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" name="is_active" checked={form.is_active} onChange={handleChange} className="w-4 h-4 accent-primary-500" />
              <span className="text-sm text-white/70">Active</span>
            </label>
            <div className="flex items-center gap-2">
              <label className="label mb-0">Order:</label>
              <input type="number" name="sort_order" value={form.sort_order} onChange={handleChange} className="input w-20 py-1.5" />
            </div>
          </div>
          <div className="flex gap-2 pt-2">
            <button type="submit" disabled={saving} className="btn-primary flex-1 justify-center">
              {saving ? 'Saving...' : (service ? 'Update Service' : 'Create Service')}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function ServicesPage() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalService, setModalService] = useState(undefined); // undefined = closed, null = new
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const res = await getAdminServices();
      setServices(res.data.data || []);
    } finally { setLoading(false); }
  };

  const handleSave = async (form, id) => {
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v === true ? '1' : v === false ? '0' : v || ''));
      if (id) {
        fd.append('_method', 'PUT');
        const res = await updateService(id, fd);
        setServices(prev => prev.map(s => s.id === id ? res.data.data : s));
        toast.success('Service updated');
      } else {
        const res = await createService(fd);
        setServices(prev => [...prev, res.data.data]);
        toast.success('Service created');
      }
      setModalService(undefined);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to save');
    }
  };

  const handleDelete = async () => {
    try {
      await deleteService(deleteId);
      setServices(prev => prev.filter(s => s.id !== deleteId));
      toast.success('Service deleted');
      setDeleteId(null);
    } catch { toast.error('Failed to delete'); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl font-semibold text-white">Services</h1>
          <p className="text-white/40 text-sm mt-0.5">{services.length} services</p>
        </div>
        <button onClick={() => setModalService(null)} className="btn-primary"><Plus size={15} /> Add Service</button>
      </div>

      {loading ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...Array(6)].map((_, i) => <div key={i} className="card p-5"><div className="skeleton h-10 w-10 rounded-xl mb-3" /><div className="skeleton h-4 w-3/4 rounded mb-2" /><div className="skeleton h-3 w-full rounded" /></div>)}
        </div>
      ) : services.length === 0 ? (
        <div className="card p-12 text-center">
          <Wrench size={32} className="mx-auto mb-3 text-white/10" />
          <p className="text-white/30 text-sm">No services yet</p>
          <button onClick={() => setModalService(null)} className="btn-primary mt-4 mx-auto"><Plus size={14} /> Add Service</button>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map(service => (
            <div key={service.id} className="card p-5 group relative">
              <div className="absolute top-3 right-3 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <button onClick={() => setModalService(service)} className="btn-ghost p-1.5"><Edit size={12} /></button>
                <button onClick={() => setDeleteId(service.id)} className="btn-ghost p-1.5 text-red-400/60 hover:text-red-400 hover:bg-red-500/10"><Trash2 size={12} /></button>
              </div>
              <div className="w-10 h-10 bg-primary-500/10 rounded-xl flex items-center justify-center mb-3 text-lg">
                {service.icon || '✦'}
              </div>
              <h3 className="font-medium text-white mb-1.5">{service.title}</h3>
              <p className="text-white/40 text-xs leading-relaxed line-clamp-3">{service.short_description}</p>
              <div className="flex items-center gap-2 mt-3">
                <span className={`w-1.5 h-1.5 rounded-full ${service.is_active ? 'bg-green-400' : 'bg-white/20'}`} />
                <span className="text-white/30 text-xs">{service.is_active ? 'Active' : 'Inactive'}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {modalService !== undefined && (
        <ServiceModal service={modalService} onSave={handleSave} onClose={() => setModalService(undefined)} />
      )}
      <ConfirmModal open={!!deleteId} title="Delete Service" message="Delete this service?" onConfirm={handleDelete} onCancel={() => setDeleteId(null)} danger />
    </div>
  );
}